import { Image as ImageLucide, ImageOff } from 'lucide-react';
import React, { useRef } from 'react';
import { useAuth, useTheme } from '../global-components/src';
import { User } from '../global-components/src/types';
import { t } from 'i18next';
import { Icon } from '../global-components/src/components/icon';
import { compressImage, convertHeic } from '../global-components/src/utils/file';

interface Props { 
  user: User | undefined, 
  onDelete: () => void 
  setError: (error: string) => void 
  setLoading: (loading: boolean) => void 
  setIsOpen: (loading: boolean) => void 
  setImgSrc: (val: string) => void 
}
 
const AddBanner = ({ user, onDelete, setIsOpen, setError, setImgSrc }: Props) => {
  const { user: authUser } = useAuth();
  const inputRef = useRef<HTMLInputElement | null>(null);

  const onSelectFile = async(e: React.ChangeEvent<HTMLInputElement>) => {
    let file = e.target.files?.[0];
    if (!file) return;
    file = await convertHeic(file);
    file = await compressImage(file, .95);
    
    // Limpar input para permitir selecionar o mesmo arquivo novamente
    if (inputRef.current) {
      inputRef.current.value = '';
    }
    
    const reader = new FileReader();
    
    reader.onload = async(event) => {
      const imageUrl = event.target?.result?.toString() || "";
      
      if (!imageUrl) {
        setError("Erro ao carregar imagem.");
        return;
      }
      
      // Verifique se o arquivo é um GIF
      if (file.type === "image/gif") {
        setImgSrc(imageUrl);
        setIsOpen(true);
        return;
      }
      
      // Para outras imagens, verificar dimensões
      const imageElement = new Image();
      imageElement.src = imageUrl;
      
      imageElement.onload = () => {
        const { naturalWidth, naturalHeight } = imageElement;
        
        if (naturalWidth < 150 || naturalHeight < 150) {
          setError("A imagem precisa ter pelo menos 150 x 150 pixels.");
          return;
        }
        
        setImgSrc(imageUrl);
        setIsOpen(true);
      };
      
      imageElement.onerror = () => {
        setError("Erro ao carregar imagem.");
      };
    };
    
    reader.onerror = () => {
      setError("Erro ao ler arquivo.");
    };
    
    reader.readAsDataURL(file);
  };

  return (
    <>
      {user && user?.id === authUser?.id ? (
        <li>
          <ul className="ul-normal">
            <label htmlFor="banner" className="dropdown-item cursor-pointer user-select-none">
              <div className="div-icon-fix">
                <ImageLucide className="icon-config-post" />
                {t("user.addBanner")}
              </div>
            </label>
          </ul>

          <input ref={inputRef} type="file" name="banner" id="banner" accept="image/*" onChange={onSelectFile} className="input-file-hidden" />
        </li>
      ) : null}

      {(user?.can_remove_photo || user?.id === authUser?.id) && user?.img_banner && (
        <li>
          <ul className="ul-normal">
            <div onClick={onDelete} className="dropdown-item cursor-pointer user-select-none">
              <div className="div-icon-fix">
                <ImageOff className='icon-config-post'/>
                {t("user.removeBanner")}
              </div>
            </div>
          </ul>
        </li>
      )}
    </>
  );
};

export default AddBanner;